import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
const before = ['Sonntagabends auf der Suche nach einer Idee für Montag', 'Material aus zehn verschiedenen Quellen zusammengesucht', 'Unsicher, weil du selbst kein Instrument spielst', 'Musizierstunden, die zu laut werden und aus dem Ruder laufen', 'Kein roter Faden über die Klassenstufen hinweg'];
const after = ['Fertige Stunden mit Lehrer-Skript zum Vorlesen', 'Ein Band für jede Klassenstufe – von Klasse 1 bis 10', 'Kein Instrument und keine Notenkenntnisse nötig', 'Materiallisten mit kostenlosen Alternativen', 'Ein aufeinander aufbauendes Curriculum für zehn Jahre'];
const highlights: [string, string][] = [['600', 'Seiten'], ['8 Einheiten', 'pro Band'], ['100 %', 'Druckfertig und digital']];
export function TransformationSection() {
  return <section className="bg-brand-main px-5 py-16 md:py-24" data-id="element-166" data-mp="208fwb3qsxzmx">
      <Reveal className="mx-auto max-w-[1100px]" data-id="element-167" data-mp="fb2jb68nbtdn">
        <div className="mx-auto max-w-3xl text-center" data-id="element-168" data-mp="faao3wiynxnw">
          <Eyebrow data-id="element-169" data-mp="k1ixwto7dl1l">Ein besserer Weg, Musik zu unterrichten</Eyebrow>
          <h2 className="mt-5 text-3xl font-extrabold leading-[1.15] tracking-tight text-brand-navy md:text-[2.6rem]" data-id="element-170" data-mp="k3vnnt07czp7">
            Von der leeren Musikstunde zur{' '}
            <span className="italic text-brand-orange" data-id="element-171" data-mp="acra8xq6dmwh">
              sicheren Musiklehrkraft.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-172" data-mp="xzh9jrb533de">
            Jeder Band nimmt dir die Vorbereitung ab – mit fertigen Stunden,
            Materiallisten und Bildfolgen für jede Unterrichtsstunde. So kannst
            du dich auf das Wesentliche konzentrieren: das Unterrichten und die
            Freude an der Musik.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl gap-4 sm:grid-cols-3" data-id="element-173" data-mp="39t7fqfgqi1qp">
          {highlights.map(([value, label]) => <div key={label} className="rounded-xl border border-brand-line bg-brand-alt px-5 py-6 text-center shadow-sm" data-id="element-174" data-mp="1k9zcu5ukz9le">
              <strong className="block font-display text-2xl font-extrabold leading-none text-brand-orange" data-id="element-175" data-mp="1fbo4jzjxp75a">
                {value}
              </strong>
              <span className="mt-3 block text-[11px] font-bold uppercase tracking-[0.1em] text-brand-gray" data-id="element-176" data-mp="15luw37f39859">
                {label}
              </span>
            </div>)}
        </div>

        <div className="grid items-stretch gap-6 md:grid-cols-2" data-id="element-177" data-mp="wk54o1l7i97h">
          <Comparison title="Vorher" items={before} positive={false} data-id="element-178" data-mp="wmr8bq4z84kf" />
          <Comparison title="Mit Musik Startklar" items={after} positive data-id="element-179" data-mp="rlk39yu7xjhg" />
        </div>
        <p className="mt-10 text-center text-sm italic text-brand-gray" data-id="element-180" data-mp="mnihh65er62a">
          Das komplette Musik-Curriculum, das deine Vorbereitung auf wenige
          Minuten verkürzt.
        </p>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`h-full rounded-xl border bg-brand-alt p-7 md:p-9 ${positive ? 'border-brand-orange/40 shadow-md' : 'border-brand-line shadow-sm'}`} data-id="element-181" data-mp="2thj5s7l9qncu">
      <h3 className="mb-6 font-display text-lg font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-182" data-mp="337c8sk7chu5h">
        {title}
      </h3>
      <ul className="space-y-4" data-id="element-183" data-mp="26kh7xx3vc9ib">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-184" data-mp="2akrgnhj1pe0v">
            <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-orange/10 text-brand-orange' : 'bg-brand-gray/10 text-brand-gray'}`} data-id="element-185" data-mp="2fijip4demgis">
              <Icon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-186" data-mp="3vx2mis52eu12" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-187" data-mp="18olol7mvm51o">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}